/** dayjs `day()` 下标 → 小写英文星期名（0 = sunday）。与语言无关，永远不要用 format('dddd') 取星期。 */
export const WEEKDAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
